import { IContacts } from '../../types/offer';
import { IOfferDesktopSchema } from '../../repositories/offers-comparison/entities/offer/OfferDesktopSchema';
import { phoneToString } from '../../utils/phone';

export function transformComparisonContacts({ contacts }: IOfferDesktopSchema): IContacts {
  return {
    ...contacts,
    formattedPhone: phoneToString(contacts),
  };
}
